export default {
    login_register: 'Prijava/Registracija',
    booking_confirmation_title: 'Potvrda rezervacije',
    booking_confirmation_body: 'Hvala na vašoj rezervaciji. Detalje potvrde pronađite ispod.',
    insurance_requirements_modal_disclaimer: `Rezervacijom potvrđujem da: u poslednjih 5 godina nisam imao/la presude ili saobraćajne prekršaje. Nije mi odbijena ponuda, otkazana polisa ili odbijeno obnavljanje, niti mi je bilo koji osiguravač nametnuo posebne uslove ili povećanu premiju. Nisam bio/la diskvalifikovan/a za vožnju. Nemam pokrenutih sudskih postupaka ili policijskih istraga. Nemam presuda za krađu, prevaru ili nepoštenje u poslednjih 5 godina. Ne bolujem od oštećenja vida ili sluha (koje nije ispravljeno naočarima ili slušnim aparatom), srčanih bolesti, dijabetesa, napada ili bilo kakve fizičke ili mentalne slabosti. Nisam imao/la nezgoda u poslednjih 5 godina. Kliknite {0} ako ne ispunjavate ove uslove.`,
    insurance_requirements_here: 'ovde',
    insurance_requirements: 'Pročitao/la sam i razumem {0}',
    ir: 'Uslovi osiguranja',
    location: 'Lokacija',
    pickup_location: 'Mesto preuzimanja',
    dropoff_location: 'Mesto vraćanja',
    vehicle: 'Vozilo',
    pickup_and_dropoff: 'Preuzimanje i vraćanje (lokalno vreme)',
    view_voucher: 'Pogledaj vaučer',
    identity_verification_body: 'Biće potrebno da potvrdite identitet pre preuzimanja vozila',
    identity_verification_title: 'Potvrda identiteta',
    search_again: 'Pretraži ponovo',
    refrigerated: 'rashlađeno',
    aircon_lower: 'klima',
    aircon: 'Klima uređaj',
    refrigeration: 'Rashlađeno',
    not_available: 'Drive & Go je trenutno dostupan samo osobama sa dokumentima iz sledećih zemalja.',
    check_if_included: 'Proverite da li je vaša zemlja uključena.',
    included_in_booking: 'Uključeno u ovu rezervaciju',
    cdw_with_excess: 'CDW sa učešćem',
    theft_protection: 'Zaštita od krađe sa učešćem',
    risk_reduction: 'Smanjenje rizika',
    free_extras: 'Uz ovu rezervaciju imate pravo na dva besplatna dodatka <br />.',
    continue: 'Nastavi',
    luggage_large_short_label: 'V',
    luggage_medium_short_label: 'S',
    luggage_small_short_label: 'M',
    luggage_large_long_label: 'veliki',
    luggage_medium_long_label: 'srednji',
    luggage_small_long_label: 'mali',
    fuel_unspecified_label: 'neodređeno',
    transmission_manual_label: 'Manuelni',
    transmission_automatic_label: 'Automatski',
    make_a_booking: 'Rezerviši',
    pickup_date: 'Datum preuzimanja',
    dropoff_date: 'Datum vraćanja',
    driver_age: 'Vozač između 30 - 65',
    enter_driver_age: 'Unesite godine vozača',
    promo_code: 'Promo kod',
    search: 'Pretraži',
    dropoff_date_cannot_be_before_pickup_date: 'Datum vraćanja ne može biti pre datuma preuzimanja',
    pickup_date_cannot_be_in_the_past: 'Datum preuzimanja ne može biti u prošlosti',
    pickup_time_cannot_be_in_the_past: 'Vreme preuzimanja ne može biti u prošlosti',
    dropoff_time_must_be_later_than_the_pickup_time_if_on_the_same_day: 'Vreme vraćanja mora biti kasnije od vremena preuzimanja ako je isti dan',
    vehicle_filters: 'Filteri vozila',
    reset: 'Poništi',
    transmission: 'Menjač',
    all: 'Svi',
    manual: 'Manuelni',
    auto: 'Automatski',
    passengers: 'Putnici',
    vehicle_type: 'Tip vozila',
    filter: 'Filtriraj',
    vehicle_search: 'Pretraga vozila',
    edit: 'Izmeni',
    no_results: 'Nema rezultata prema zadatim filterima.',
    small_cars: 'Mali automobili',
    medium_cars: 'Srednji automobili',
    large_cars: 'Veliki automobili',
    estate_cars: 'Karavani',
    suvs: 'SUV vozila',
    mpvs: 'MPV vozila',
    vans: 'Kombi vozila',
    camper_vans: 'Kamperi',
    premium: 'Premium',
    unspecified: 'neodređeno',
    large: 'veliki',
    medium: 'srednji',
    small: 'mali',
    automatic: 'automatski',
    you_have_been_refunded: 'Povraćaj je izvršen.',
    please_customer_service: 'Za rezervaciju kontaktirajte našu korisničku podršku.',
    contact_customer_service: 'Kontaktirajte korisničku podršku',
    booking_failed: 'Rezervacija nije mogla biti obrađena.',
    summary: 'Sažetak',
    reforestation_and_protection: 'Podržite pošumljavanje i zaštitu prašuma širom Kostarike',
    cost_of_rental: 'Cena najma',
    to_pay_now: 'Za platiti sada',
    greenheart_donation: 'Donacija Green Heart',
    total_cost: 'Ukupna cena najma',
    tc_agreement: 'Pročitao/la sam i razumem {0}.',
    tc: 'Uslovi i odredbe',
    receive_offers: 'Želim da primam posebne ponude putem e-maila.',
    donate: 'Da, želim da doniram {amount}',
    pay_now: 'Plati {amount} sada',
    driver_details: 'Podaci o vozaču',
    complete_driver_details: 'Molimo popunite podatke o vozaču.',
    are_you_the_driver: 'Da li ste vi vozač?',
    have_an_account: 'Već imate nalog?',
    login: 'Prijava',
    or: 'ili',
    first_name: 'Ime vozača',
    last_name: 'Prezime vozača',
    email: 'Email adresa',
    phone_number: 'Broj mobilnog telefona',
    unable_to_save_driver_information: 'Nije moguće sačuvati podatke o vozaču. Pokušajte ponovo.',
    pay_online_now: 'Plati sada',
    day: 'Dan',
    choose_location: 'Izaberite lokaciju',
    location_not_found: 'Nažalost, nismo pronašli traženu lokaciju.',
    add: 'Dodaj',
    remove: 'Ukloni',
    free_extra: 'Besplatan dodatak',
    free: 'BESPLATNO!',
    fast_track_notice: 'Ograničenja porekla dokumenata važe za ovu uslugu. Dostupno samo osobama sa dokumentima iz',
    complete_booking: 'Završi rezervaciju',
    choose_card: 'Izaberite karticu ili dodajte novu.',
    add_billing_details: 'Dodajte podatke za naplatu.',
    card_number: 'Broj kartice',
    card_holder_name: 'Ime vlasnika kartice',
    card_exp: 'MM / GG',
    card_cvc: 'CVC',
    save_card: 'Sačuvati karticu?',
    amount_charged: 'Vaša kartica će biti zadužena',
    payment_confirmation: 'Potvrdi rezervaciju i plati',
    payment_methods: 'dostupni načini plaćanja',
    use_saved_card: 'x koristi sačuvanu karticu',
    use_different_card: '+ koristi drugu karticu',
    book_now: 'Rezerviši sada',
    minimum_age: 'Samo za starije od {age}',
    excess_liability: 'Učešće',
    security_deposit: 'Sigurnosni depozit',
    fuel_policy: 'Politika goriva',
    like_for_like: 'Isto za isto',
    full_to_full: 'Puno za puno',
    miles_per_rental: '{mileage} besplatnih milja po najmu',
    km_per_rental: '{mileage} besplatnih km po najmu',
    unlimited_mileage: 'Neograničena kilometraža',
    unlimited_mileage_km: 'Neograničeni kilometri',
    non_amendable: 'Nije moguće menjati',
    non_refundable: 'Nepovratno',
    free_cancellation_until: 'Besplatno otkazivanje do',
    cancellation_in_line_with: 'Otkazivanje prema',
    tcs: 'Uslovi i odredbe',
    free_extras_on_collection: 'Dva besplatna dodatka pri preuzimanju',
    glass_and_tyres_covered: 'Stakla i gume pokriveni',
    number_of_passengers: 'Broj putnika',
    number_of_bags: 'Broj torbi',
    fuel_type: 'Vrsta goriva',
    co2: 'CO2',
    book_type: 'Rezerviši {type}',
    processing: 'Obrada',
    actual_price: 'Stvarna cena',
    tooltip: 'Cena u {currencyCode} je procena na osnovu kursa, cena u {currency} je obavezujuća.',
    deposit: 'Depozit',
    pay_online: 'Plati sada',
    pay_online_without_extras: 'Cena najma',
    extras_on_arrival: 'Dodaci pri dolasku',
    insurance_on_arrival: 'Smanjenje rizika - plati pri dolasku',
    insurance_online: 'Smanjenje rizika - plati sada',
    extras_online: 'Dodaci - plati sada',
    green_heart_donation: 'Donacija Green Heart',
    why_use_drive_and_go: 'Zašto koristiti Drive & Go?',
    straight_to_car: 'Direktno do auta',
    no_queues: 'Bez čekanja',
    self_checkout: 'Samostalna prijava',
    cant_lose_key: 'Ključ se ne može izgubiti',
    online_id_check: 'Online provera identiteta',
    phone_as_key: 'Telefon kao ključ',
    premiumplus_benefits_includes: 'Uključene i Premium Plus+ pogodnosti',
    book_drive_go: 'Rezerviši Drive & Go',
    distance_allowance: 'Dozvoljena udaljenost',
    duration: 'Trajanje',
    view_more_bookings: 'Vidi više rezervacija',
    to_pay_on_arrival: 'Za platiti pri dolasku',
    pay_on_arrival: 'Plati pri dolasku',
    unlimited: 'Neograničeno',
    return_date: 'Datum vraćanja',
    postcode: 'Poštanski broj',
    country: 'Država',
    drive_and_go: {
        drive_and_go: 'Drive And Go',
        available_countries: 'Drive & Go je trenutno dostupan samo osobama sa dokumentima iz sledećih zemalja:',
        drive_and_go_today: 'Drive & Go rezervacija za danas!',
        drive_and_go_shortened: 'Drive & Go',
        why_use_drive_and_go: 'Zašto koristiti Drive & Go?',
        straight_to_car: 'Direktno do auta',
        no_queues: 'Bez čekanja',
        self_checkout: 'Samostalna prijava',
        cannot_lose_the_key: 'Ključ se ne može izgubiti',
        online_id_check: 'Online provera identiteta',
        phone_as_a_key: 'Telefon kao ključ',
        premium_plus_benefits_also_included: 'Uključene i Premium Plus+ pogodnosti',
        book_drive_and_go: 'Rezerviši Drive & Go',
    },
    car_and_camp: {
        tent_and_equipment: 'Šator i oprema',
        quick_and_easy: 'Brzo i jednostavno za postavljanje',
        travel_freedom: 'Sloboda putovanja',
        affordable_campervan_alternative: 'Pristupačna alternativa kamperu',
        lightweight_and_compact: 'Lagano i kompaktno',
        fully_insured: 'Potpuno osigurano',
    },
    my_bookings: 'Moja rezervacija',
    no_bookings: 'Nema rezervacija',
    my_profile: 'Moj profil',
    no_bookings_to_display: 'Nema rezervacija za prikaz.',
    search_great_car_rental_deals: 'Pretraži odlične ponude rentanja auta za vaše sledeće putovanje.',
    odometer_at_collection: 'Brojač kilometara pri preuzimanju',
    fuel_at_collection: 'Gorivo pri preuzimanju',
    start_check_in: 'Započni prijavu',
    start_collection: 'Započni preuzimanje',
    recent_bookings: 'Nedavna rezervacija',
    damage: {
        updated_damage_report_submitted: 'Ažurirani izveštaj o šteti je poslat. Naš tim korisničke podrške će vas kontaktirati po potrebi.',
        add_additional_damage: 'Dodaj dodatnu štetu',
        you_may_report_additional_damage_up_to: 'Dodatnu štetu možete prijaviti do 24 sata nakon povraćaja vozila',
        specify_damage: 'Navedite štetu',
        please_choose_the_area_and_type_of_damage: 'Izaberite područje i vrstu štete',
        type_of_damage: 'Vrsta štete',
        is_this_more_than_5_cm: 'Da li je ovo više od 5 cm?',
        please_take_or_select_a_photo: 'Slikajte ili izaberite fotografiju',
        please_take_a_photo_ensuring_the_damage_is_clearly_visible: 'Slikajte tako da je šteta jasno vidljiva',
        if_you_require_you_may_add_another_photo_select_the_icon_to_add_another_photo: ' Po potrebi možete dodati još jednu fotografiju, izaberite ikonu za dodavanje',
        save_image: 'Sačuvaj sliku',
        save_images: 'Sačuvaj slike',
        damage_saved_successfully: 'Šteta uspešno sačuvana',
        add_photo: 'Dodaj fotografiju',
    },
    checkout: {
        start_collection: 'Započni preuzimanje',
        collect_vehicle: 'Preuzmi vozilo',
        we_will_let_you_know_the_details: 'Obavestićemo vas o lokaciji i detaljima za preuzimanje vozila.',
        inspect: 'Pregledaj',
        we_will_ask_for_four_photos_from_each_corner: 'Tražićemo četiri fotografije iz svakog ugla vozila i sve nove štete koje nisu već navedene.',
        fuel_and_milage: 'Gorivo i kilometraža',
        you_confirm_the_readings_at_the_start_of_your_hire: 'Potvrđujete očitanja brojača kilometara i goriva na početku najma.',
        sign: 'Potpiši',
        sign_the_rental_agreement: 'Potpiši ugovor o najmu.',
        away_you_go: 'Srećan put',
        you_are_free_to_take_to_the_road: 'Slobodno krenite na put!',
        collect_your_vehicle: 'Preuzmite svoje vozilo',
        get_directions: 'Upute za dolazak',
        hide_directions: 'Sakrij upute',
        local_time: 'lokalno vreme',
        tel: 'Tel',
        getting_to_the_location: 'Dolazak na lokaciju',
        get_vehicle_details: 'Detalji o vozilu',
        view_map: 'Pogledaj mapu',
        unlock_vehicle_and_continue: 'Otključaj vozilo i nastavi',
        unable_to_connect_to_vehicle: 'Nije moguće povezati se sa vozilom',
        we_were_unable_to_connect_to_the_vehicle_please_check: 'Nismo se mogli povezati sa vozilom – proverite da li ste pored pravog vozila i pokušajte ponovo.',
        we_were_unable_to_find_the_vehicle_booking_please_try_again_later: 'Nismo pronašli rezervaciju vozila. Pokušajte kasnije.',
        odometer_and_fuel: 'Brojač kilometara i gorivo',
        odometer: 'Brojač kilometara',
        please_confirm_the_odometer_and_fuel_readings: 'Ako je moguće, potvrdite očitanja brojača kilometara i goriva.',
        the_odometer_field_is_required: 'Polje brojača kilometara je obavezno',
        and_must_be_greater_than_the_checkout_odometer: 'i mora biti veće od brojača kilometara pri preuzimanju',
        confirm: 'Potvrdi',
        please_take_a_photo_from_each_corner_of_the_vehicle: 'Slikajte iz svakog ugla vozila',
        pre_existing_damage: 'Postojeća šteta',
        no_pre_existing_damage: 'Nema postojeće štete.',
        new_damage: 'Nova šteta',
        add_additional_damage: 'dodaj dodatnu štetu',
        no_new_damage_to_report: 'Nema nove štete za prijaviti',
        checkout_complete: 'Preuzimanje završeno',
        start_rental: 'Započni najam',
        congratulations_name_it_is_time_to_take_to_the_road: 'Čestitamo {customer_name}, vreme je za put!',
        we_are_unable_to_complete_your_vehicle_checkout: 'Ne možemo završiti preuzimanje vozila.',
        please_do_the_following: 'Molimo uradite sledeće',
        remove_all_belonging_and_lock_the_vehicle: 'Uklonite sve stvari i zaključajte vozilo.',
        lock_vehicle: 'Zaključaj vozilo',
        once_you_have_contacted_customer_services: 'Nakon što kontaktirate korisničku podršku',
        vehicle_location: 'Lokacija vozila',
        collect_your: 'Preuzmite svoj',
        from: 'Od',
        key_in_glove_box: 'vaš ključ se nalazi u pretincu za rukavice',

        keyholder: {
            not_detected: 'Ključ nije detektovan u držaču ključa',
            not_detected_please_try_again: 'Stavite ključ u držač i pokušajte ponovo.',

            not_installed: 'Držač ključa nije instaliran',
            not_installed_please_contact_customer_service: 'Držač ključa nije instaliran, kontaktirajte korisničku podršku.',
        },
        keyring: {
            look_up_failed: 'Pretraga priveza za ključ nije uspela',
            look_up_failed_please_contact_customer_service: 'Pretraga priveza za ključ nije uspela, kontaktirajte korisničku podršku.',
        },
        key: {
            invalid: 'Ključ nije validan',
            invalid_please_contact_customer_service: 'Vaš ključ nije validan, kontaktirajte korisničku podršku.',

            expired: 'Ključ je istekao',
            expired__please_contact_customer_service: 'Vaš ključ je istekao, kontaktirajte korisničku podršku.',
        },
    },
    checkin: {
        start_check_in: 'Započni prijavu',
        vehicle_location: 'Lokacija vozila',
        tell_us_where_you_have_parked: 'Recite nam gde ste parkirali vozilo.',
        fuel_and_milage: 'Gorivo i kilometraža',
        you_confirm_the_readings_at_the_end_of_your_hire: 'Potvrđujete očitanja brojača kilometara i goriva na kraju najma.',
        inspect: 'Pregledaj',
        we_will_as_for_four_photos_from_each_corner_of_the_vehicle_along_with_any_new_damage: 'Tražićemo četiri fotografije iz svakog ugla vozila i sve nove štete nastale tokom najma.',
        lock: 'Zaključaj',
        check_you_have_left_no_belonging_then_lock_the_vehicle: 'Proverite da li ste uklonili sve stvari i zaključajte vozilo.',
        please_tell_us_where_you_have_parked_the_vehicle: 'Recite nam gde ste parkirali vozilo',
        once_the_vehicle_is_locked_you_will_be_unable_to_unlock_it_again: 'Nakon što zaključate vozilo, nećete ga moći ponovo otključati.',
        name_please_check_you_have_left_no_belongings_then_lock_the_vehicle: '{first_name}, proverite da li ste uklonili sve stvari, zaključajte vozilo i po potrebi vratite fizički ključ u držač.',
        lock_vehicle: 'Zaključaj vozilo',
        complete_check_in: 'Završi prijavu',
        inspection: 'Pregled',
        complete_vehicle_check_in: 'Završi prijavu vozila',
        we_are_unable_to_complete_your_vehicle_check_in: 'Ne možemo završiti prijavu vozila.',
        please_contact_customer_services: 'Kontaktirajte korisničku podršku',
        once_you_have_contacted_customer_services: 'Nakon što kontaktirate korisničku podršku',
        please_amend_odometer_to_be_greater_than: 'Ispravite brojač kilometara na više od {odometer_value}',
    },
    rental_agreement: {
        rental_agreement: 'Ugovor o najmu',
        agreement_between: 'Ugovor između',
        and: 'i',
        sign_rental_agreement: 'Potpiši ugovor o najmu',
        i_have_read_and_understood_the_terms_and_conditions: 'Pročitao/la sam i razumem uslove i prihvatam stanje vozila',
    },
    additional_options: 'Dodatne opcije',
    booking_details: 'Detalji rezervacije',
    price_for_x_days: 'Cena za {qty_of_days} dan | Cena za {qty_of_days} dana',
    cancelled: 'Otkazano',
    upcoming: 'Nadolazeće',
    active: 'Aktivno',
    full_insurance_no_deposit: 'Puno osiguranje i bez depozita',
    excess: '{amount} učešće',
    deposit: '{amount} depozit',
    included_daily_distance: '{distance} {unit} po danu',
    miles: 'milja',
    kilometers: 'kilometara',
    collection_details_title: 'Detalji preuzimanja',
    collection_details_not_found: 'Nema definisanih detalja preuzimanja za ovu lokaciju',
    free_cancellation: 'Besplatno otkazivanje',
    no_deposit: 'Bez depozita',
    benefit_from: 'Iskoristite',
    for_only_per_day: 'Za samo {price} po danu',
    upgrade_mee: 'UpgradeMee',
};
